import BaseMeasureOverlay from "./BaseMeasureOverlay";
import LineString from "ol/geom/LineString";

class LineDistanceMeasureOverlay extends BaseMeasureOverlay {

	onGeometryChange = (event) => {
		let coordinates = event.target.getCoordinates();
		let lineString = new LineString(
			[coordinates[coordinates.length - 2], coordinates[coordinates.length - 1]]
		);
		let position = lineString.getFlatMidpoint();
		let distance = lineString.getLength() * this.uperpixel;
		if (parseInt(distance) === 0)
			return this.close();
		this.overlay.setPosition(position);
		if (distance >= 1000) {
			this.overlay.element.innerHTML = (distance / 1000).toFixed(2) + ' mm';
			this.overlay.element.innerHTML = '<p style="color: DarkBlue; font-weight: bold; font-size:20px; ' +
				'text-shadow: 0 0 5px white">' + (distance / 1000).toFixed(2) + 'mm' + '</p>'
		} else {
			this.overlay.element.innerHTML = '<p style="color: DarkBlue; font-weight: bold; ; font-size:20px; ' +
				'text-shadow: 0 0 5px white">' + distance.toFixed(2) + 'um' + '</p>';
		}
	}
}

export default LineDistanceMeasureOverlay;
